import { LEARNING_MODULES, MODULE_ORDER } from "@/data/appData";
import { localizeModule } from "@/lib/localizeContent";

export const CODE_BASE = { en: "/code", es: "/es/codigo" };

const orderIndex = (id) => { const i = MODULE_ORDER.indexOf(id); return i === -1 ? 999 : i; };

// Flat, localized list of every code section across the Learning Center, grouped by module order.
export function codeIndex(lang) {
  return LEARNING_MODULES
    .filter((m) => m.codeSections?.length)
    .sort((a, b) => orderIndex(a.id) - orderIndex(b.id))
    .map((m) => {
      const { module } = localizeModule(m, lang);
      return { id: m.id, title: module.title, sections: module.codeSections.map((cs) => ({ ...cs, moduleId: m.id, moduleTitle: module.title })) };
    });
}

export function findCodeSection(slug, lang) {
  for (const g of codeIndex(lang)) {
    const cs = g.sections.find((s) => s.id === slug);
    if (cs) return { section: cs, group: g };
  }
  return null;
}
